module.exports = __webpack_public_path__ + "static/startupi-a66eea2a5527cb2918e242c876478527.png";